import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { lsGet, lsRemove } from "../lib/safeStorage";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/");
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        // strip the hash
        window.history.replaceState(null, "", window.location.pathname);

        // Persist the consent timestamp captured on Splash, if pending and the
        // user record does not already have one.
        try {
          const pending = lsGet("habano.legal_agreed_pending");
          const existing = data?.user?.terms_accepted_at;
          if (pending && !existing) {
            await api.patch("/users/me", { terms_accepted_at: pending });
          }
          lsRemove("habano.legal_agreed_pending");
        } catch { /* ignore */ }

        const u = data?.user || {};
        const roleSelected = !!u.role_selected_at;
        // iter177 — Restore the stashed destination first (Get Listed
        // auth gate). Applies to fully-onboarded users too so a
        // returning admin/business tapping Get Listed while logged out
        // lands back on the form after OAuth.
        let next = null;
        try { next = sessionStorage.getItem("habano.auth.next"); } catch { /* ignore */ }
        if (next && roleSelected) {
          try { sessionStorage.removeItem("habano.auth.next"); } catch { /* ignore */ }
          navigate(next, { replace: true });
          return;
        }
        if (!roleSelected && u.role !== "vendor" && u.role !== "business" && u.role !== "admin") {
          navigate("/select-role", { state: { user: u } });
        } else if (u.role === "admin") {
          navigate("/admin", { replace: true });
        } else if (u.role === "vendor") {
          navigate("/vendor", { replace: true });
        } else if (u.role === "business") {
          navigate("/business", { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      } catch (e) {
        console.error(e);
        navigate("/?auth=failed");
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen grid place-items-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="eyebrow">Habano</div>
        <div className="font-display text-2xl mt-2">Signing you in…</div>
      </div>
    </div>
  );
}
